import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import Suppliers from 'components/supplier';

const SuppliersRoute: React.FC = () =>
{

  return (
    <PermissionGuard
      permission={Suppliers.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<Pages.Suppliers />} />
        <Route path="/page/:pageNum" element={<Pages.Suppliers />} />
        <Route path="/page" element={<Pages.Suppliers />} />
        <Route path="/:id/*" element={<Pages.Supplier />} />
        <Route path="/create" element={<Pages.Supplier />} />
      </Routes>
    </PermissionGuard>
  );
};

export default SuppliersRoute;

